import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import styles from "./Dashboard.module.scss";

import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Grid from "../../components/Grid";
import { apiRequest } from "../../utils/api";
import Spacer from "../../utils/spacer";

import BarChart from "../../components/BarChart";
import BarChartStackedMulti from "../../components/BarChartStackedMulti";
import RadialChart from "../../components/RadialChart";
import TaskWidget from "../../components/TaskWidget";

import { useCampaign } from "../../context/campaign";
import { getLocalValue } from "../../utils/auth";

import GetAllCountries from "../../components/GetAllCountries";
import MultiBarChart from "../../components/MultiBarChart";
import { IsCEO, IsExecutive } from "../../config/Roles";

import { useTranslation } from "react-i18next";
import DashboardMetrics from "../../components/DashboardMetrics";
import ReportDownload from "../../components/ReportDownload";
import getUserIP, { formatIPJSON } from "../../utils/getUserIP";

const COEDashboard = ({ country = false }) => {
  const {
    Parser,
    transforms: { unwind },
  } = require("json2csv");
  const { t } = useTranslation();
  const [filterValue, setFilterValue] = useState(["monthly"]);
  const { selectedCampaign } = useCampaign();
  const coach_id = getLocalValue("uid");
  const coe_id = getLocalValue("uid");
  const userFullName = getLocalValue("u_fullname");
  const filterBy = ["monthly", "quarterly", "yearly"];
  const [metricsValue, setMetricsValue] = useState(null);
  const [sessionTypeMetrics, setSessionTypeMetrics] = useState({
    data: [],
    totalDataLength: 0,
    maxValue: 0,
  });
  const [barChartStackedData, setBarChartStackedData] = useState(null);
  const [compareValue, setCompareValue] = useState(coach_id);
  const [coachList, setCoachList] = useState(null);

  const [campaignSessions, setCampaignSession] = useState(null);

  const [upcomingTask, setUpcomingTask] = useState(null);
  const [topCountries, setTopCountries] = useState(null);
  const [overdueTask, setOverdueTask] = useState(null);

  const [open, setOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    country ? country : "0"
  );

  const [happinessMetrics, setHappinessMetrics] = useState(null);
  const [complimentMetrics, setComplimentMetrics] = useState(null);
  const [successMetrics, setSuccessMetrics] = useState(null);

  const [mostCoachedSubjectList, setMostCoachedSubjectList] = useState(null);
  const [mostFailedSubjectList, setMostFailedSubjectList] = useState(null);
  const [topSkillToImprove, setTopSkillToImprove] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ops, setOps] = useState("OP-");
  const [reporting, setReporting] = useState(0);

  const anchorRef = useRef(null);
  const [userIP, setUserIP] = useState(null);

  useEffect(() => {
    getUserIP().then(res => setUserIP(formatIPJSON(res)));
  }, []);

  useEffect(() => {
    if (country) {
      setSelectedCountry(country);
    }
  }, [country]);

  const handleChange = event => {
    setFilterValue(event.target.value);
  };

  const handleToggle = () => {
    // setOpen(prevOpen => !prevOpen);
    setDialogOpen(prevOpen => !prevOpen);
  };

  const getCampaignSessionsForCOE = () => {
    apiRequest
      .get(
        `/api/getCampaignSessionsForCOE?countryId=${selectedCountry}&coeId=${coe_id}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;

          setCampaignSession({
            ...data,
            totalUsageRate: data.totalUsageRate ? data.totalUsageRate : 0,
          });
        }
      })
      .catch(error => { });
  };

  const getCampaignDashboardMetrics = () => {
    apiRequest
      .get(
        `/api/getCampaignManagerDashboardMetrics?coach_id=${compareValue}&filter=${filterValue}&campaign_id=${selectedCampaign}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setMetricsValue(data);
        }
      })
      .catch(error => { });
  };

  const getCampaignCoachesTaskMetrics = () => {
    apiRequest
      .get(
        `/api/getCOECoachesTaskMetrics?coe_id=${coe_id}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setOverdueTask(data.overdue_task);
          setUpcomingTask(data.upcoming_task);
        }
      })
      .catch(error => { });
  };
  const getTopCountryList = () => {
    apiRequest
      .get(
        `/api/getCOETopCountries?coe_id=${coe_id}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setTopCountries(data);
        }
      })
      .catch(error => { });
  };

  const getSessionDuration = () => {
    apiRequest
      .get(
        `/api/getCOESessionDuration?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
        }&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;

          setBarChartStackedData(data);
        }
      })
      .catch(error => { });
  };

  const getRegionalData = (data, key) => {
    if (data) {
      const regionData = data.map(item => {
        return {
          name: item.title,
          primary: item[key] ? item[key] : 0,
        };
      });

      return regionData;
      // setHappinessMetrics(regionData)
    } else {
      return [];
    }
  };

  const getCoachName = coachId => {
    if (coachList) {
      const selectedObj = coachList.filter(item => item.uid === coachId);
      return selectedObj.length ? selectedObj[0].u_fullname : userFullName;
    } else {
      return userFullName;
    }
  };

  const getMostCoachedSubject = () => {
    apiRequest
      .get(
        `/api/getCOEMostCoachedSubjects?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
        }&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;

          setMostCoachedSubjectList(data);
        }
      })
      .catch(error => { });
  };

  const getMostFailedSubject = () => {
    apiRequest
      .get(
        `/api/getCOEMostFailedSubjects?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
        }&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setMostFailedSubjectList(data);
        }
      })
      .catch(error => { });
  };
  const getCOETopSkillToImprove = () => {
    apiRequest
      .get(
        `/api/getCOETopSkillToImprove?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
        }&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setTopSkillToImprove(data);
        }
      })
      .catch(error => { });
  };

  const getCOETypeOfSession = () => {
    apiRequest
      .get(
        `/api/getCOETypeOfSession?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
        }&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          // const data = typeOfSession;

          const formattedData = [];
          let maxValue = [];

          if (!_.isEmpty(data) && !_.isEmpty(data.type_details[0])) {
            data.type_details[0].map(item => {
              maxValue.push(item.average);
              let obj = {
                average: {
                  name: "Average ",
                  value: item.average,
                },
                legends: [],
                data: [
                  {
                    name: item.session_type,
                  },
                ],
              };
              data.region_details[0][item.session_type_id].map(list => {
                obj.data[0][list.title] = list.total_count;
                obj.legends.push(list.title);
              });
              formattedData.push(obj);
            });
            setSessionTypeMetrics({
              data: formattedData,
              totalDataLength: data.type_details[0].length,
              maxValue: Math.max(...maxValue),
            });
          } else {
            setSessionTypeMetrics({
              data: [],
              totalDataLength: 0,
              maxValue: 0,
            });
          }
        }
      })
      .catch(error => { });
  };

  useEffect(() => {
    if (selectedCampaign) {
      getCampaignDashboardMetrics();
      getSessionDuration();
      getCampaignCoachesTaskMetrics();
      getTopCountryList();
      getMostCoachedSubject();
      getMostFailedSubject();
      getCOETopSkillToImprove();
      getCOETypeOfSession();
      getCampaignSessionsForCOE();
    }
  }, [
    filterValue,
    compareValue,
    selectedCampaign,
    selectedCountry,
    ops,
    reporting,
  ]);

  const handleCompareValueChange = event => {
    const value = event.target.value; // Get the numeric value (1 or 2)
    setOps(value);
  };

  const handleReportingValueChange = event => {
    const value = event.target.value; // Get the numeric value (1 or 2)
    setReporting(value);
  };

  return (
    <div className={styles.detailsContainer}>
      {/* <button
        className={styles.downloadButton}
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <GetAppOutlinedIcon fontSize="small" />
        Report
      </button> */}

      <div className={styles.row}>
        <div className={styles.taskStatusActivitiesWrapper}>
          <TaskWidget
            taskList={upcomingTask}
            upcoming
            country
            itemLabel="country"
            itemCount="count"
            linkID="region_id"
            nameParam="country"
          />
          <TaskWidget
            taskList={overdueTask}
            overdue
            country
            itemLabel="country"
            itemCount="count"
            linkID="region_id"
            nameParam="country"
          />

          <TaskWidget
            taskList={topCountries}
            topCountries
            ranking
            itemLabel="title"
            itemCount="title"
            linkID="region_id"
            nameParam="title"
          />
        </div>
      </div>
      <div className={styles.rows}>
        <div className={styles.deptSection}>
          <h4 className={`${styles.sectionHeadlist}`}>
            {t("dashboard.coach.department")}
          </h4>
          <div style={{ display: "inline-block" }}>
            <Select
              className={styles.formSelect}
              searchable={true}
              value={ops}
              onChange={handleCompareValueChange}
            >
              <MenuItem key={"OP-"} value="OP-">
                Operations Only
              </MenuItem>
              <MenuItem key={"ALL-OP"} value="ALL">
                Operations & Non-Operations
              </MenuItem>
            </Select>
          </div>
        </div>
        <div className={styles.deptSection}>
          <h4 className={`${styles.sectionHeadlist}`}>
            {t("dashboard.coach.reportingLine")}
          </h4>
          <div style={{ display: "inline-block" }}>
            <Select
              className={styles.formSelect}
              searchable={true}
              value={reporting}
              onChange={handleReportingValueChange}
            >
              <MenuItem key={0} value="0">
                Direct reporting
              </MenuItem>
              <MenuItem key={1} value="1">
                Direct reporting & Manually Tagged
              </MenuItem>
            </Select>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        {!IsExecutive() && (
          <div className={styles.toolBar}>
            <GetAllCountries
              api={`api/getCOEAllCountries?coe_id=${coe_id}&type=${ops}&report=${reporting}`}
              countryChange={val => {
                setSelectedCountry(val);
              }}
            />
          </div>
        )}
        <h4 className={`${styles.sectionHead} ${styles.bold}`}>
          {t("dashboard.coach.campaignSession")}
        </h4>

        {selectedCampaign && campaignSessions && (
          <DashboardMetrics data={campaignSessions} />
        )}
      </div>

      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.coach.showResultFor")}
          <Select
            className={styles.sectionFilter}
            value={filterValue}
            onChange={handleChange}
            input={<Input />}
            IconComponent={ExpandMoreIcon}
          >
            {filterBy.map(filter => (
              <MenuItem key={filter} value={filter}>
                {filter}
              </MenuItem>
            ))}
          </Select>
        </h4>

        <Grid>
          <div>
            <RadialChart
              textAlign="left"
              variant="small"
              theme={"#D55757"}
              percentage="80"
              title={t("dashboard.coach.happiness")}
              label={`${t(
                "dashboard.coach.ratedSession"
              )} <span>({{chartValue}})</span> <br> ${t(
                "dashboard.coach.totalSession"
              )} <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getHappinessMetricsForCOE?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
                }&type=${ops}&report=${reporting}`}
              average="average_rated_sessions"
              totalValue="total_sessions"
              chartValue="total_rated_sessions"
              getCountryDetails={data => {
                setHappinessMetrics(
                  getRegionalData(data, "average_rated_sessions")
                );
              }}
            />

            <Spacer y={2} />

            <BarChart
              colors={["#E35646"]}
              fontColors={["#212121"]}
              maxValue={100}
              data={happinessMetrics}
              countryIcon={true}
            />
          </div>
          <div>
            <RadialChart
              textAlign="left"
              variant="small"
              theme={"#FF9C12"}
              title={t("dashboard.coach.complimentLikes")}
              label={`${t(
                "dashboard.coach.likes"
              )} <span>({{chartValue}})</span> <br> ${t(
                "dashboard.coach.totalComplements"
              )} <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getComplimentsMetricsForCOE?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
                }&type=${ops}&report=${reporting}`}
              average="average_liked_compliments"
              totalValue="total_compliments"
              chartValue="total_liked_compliments"
              campaign={selectedCampaign}
              getCountryDetails={data => {
                setComplimentMetrics(
                  getRegionalData(data, "average_liked_compliments")
                );
              }}
            />
            <Spacer y={2} />
            <BarChart
              colors={["#FF9C12"]}
              fontColors={["#212121"]}
              maxValue={100}
              data={complimentMetrics}
              countryIcon={true}
            />
          </div>
          <div>
            <RadialChart
              textAlign="left"
              variant="small"
              theme={"#13C77A"}
              percentage="73"
              title={t("dashboard.coach.success")}
              label={`${t(
                "dashboard.coach.passRate"
              )} <span>({{chartValue}})</span> <br> ${t(
                "dashboard.coach.totalSubjects"
              )}  <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getSuccessMetricsForCOE?coe_id=${coe_id}&filter=${filterValue}&country_id=${selectedCountry === "all" ? 0 : selectedCountry
                }&type=${ops}&report=${reporting}`}
              responseKey=""
              average="average_success"
              totalValue="total_coached_subject"
              chartValue="total_passed_subject"
              campaign={selectedCampaign}
              getCountryDetails={data => {
                setSuccessMetrics(getRegionalData(data, "average_success"));
              }}
            />
            <Spacer y={2} />
            <BarChart
              colors={["#13C77A"]}
              fontColors={["#212121"]}
              maxValue={100}
              data={successMetrics}
              countryIcon={true}
            />
          </div>
        </Grid>

        <Spacer y={5} />
        {mostFailedSubjectList && (
          <MultiBarChart
            graphData={mostFailedSubjectList}
            title="Most Failed subjects"
            theme="rgb(213, 87, 87)"
          />
        )}
        <Spacer y={5} />
        {mostCoachedSubjectList && (
          <MultiBarChart
            graphData={mostCoachedSubjectList}
            title="Most coached subjects"
            theme="rgb(19, 199, 122)"
          />
        )}
        <Spacer y={5} />
        {topSkillToImprove && (
          <MultiBarChart
            graphData={topSkillToImprove}
            subData="skill_details"
            id="skill_improve_id"
            title="Top skills to improve"
            theme="#2B7EFB"
          />
        )}
      </div>

      <div className={styles.row}>
        <Grid>
          <div style={{ height: "100%" }}>
            <h6 className={styles.title}>
              {t("dashboard.coach.typeOfSession")}
            </h6>
            {sessionTypeMetrics.data.map((sessionType, index) => (
              <BarChart
                key={index}
                variant="left"
                colors={["#B19AF2", "#3E2BE0", "#EDE7FC", "#7050EB"]}
                averageColors={["#BCC5D6"]}
                fontColors={["#212121"]}
                maxValue={sessionTypeMetrics.maxValue}
                average={sessionType.average}
                data={sessionType.data}
                labelX={index === 0 ? "Country" : ""}
                labelY={index === 0 ? "Sessions" : ""}
                legends={
                  index + 1 === sessionTypeMetrics.totalDataLength &&
                  sessionType.legends
                }
              />
            ))}
            {!sessionTypeMetrics.data.length && (
              <div className={styles.noData}>{t("dashboard.noDataYet")}</div>
            )}
          </div>

          {barChartStackedData && (
            <BarChartStackedMulti
              title={t("dashboard.coach.sessionDuration")}
              colors={["#0A859A", "#17AECD", "#2FC8E6", "#83DFF3"]}
              fontColors={["#fff", "#fff", "#111", "#111"]}
              legends={[
                t("dashboard.coach.plan"),
                t("dashboard.coach.do"),
                t("dashboard.coach.check"),
                t("dashboard.coach.act"),
              ]}
              data={barChartStackedData}
              showTotal
              totalSuffix="mins"
              labelX={t("dashboard.coach.length")}
              labelY={t("dashboard.coach.minutes")}
            />
          )}
        </Grid>
      </div>
      {/* Report Download Dialog */}
      <ReportDownload
        dialogOpen={dialogOpen}
        isCoordinator={IsCEO()}
        setDialogOpen={setDialogOpen}
        userIp={userIP}
      />
    </div>
  );
};

export default COEDashboard;